/**
 * @generated SignedSource<<1ce52547648e0c3e54ac7f940b8795f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopBar_user$data = {
  readonly authMetadata?: {
    readonly emailOnly: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"AccountNav_user" | "CartNav_user" | "LogoNav_user" | "SearchBar_user">;
  readonly " $fragmentType": "TopBar_user";
};
export type TopBar_user$key = {
  readonly " $data"?: TopBar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopBar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_user",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AccountNav_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CartNav_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SearchBar_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LogoNav_user"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserExistsMetadataType",
          "kind": "LinkedField",
          "name": "authMetadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailOnly",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "df557f24fed4c6a63ef918e73df85c5e";

export default node;
